import { AuthModel } from '@gtpl/shared-models/common-models';
import { JobManagementApiService } from '@gtpl/shared-services/job-management-api';
import { Module } from '@nestjs/common';
import { AssetManagementController } from '../asset-management/asset-mgmt.controller';
import { AssentManagementJobService } from '../asset-management/asset-mgmt.service';
import { RedisHelperModule } from '../redis/redis-helper.module';
@Module({
  imports: [RedisHelperModule],
  controllers: [AssetManagementController],
  providers: [AssentManagementJobService, AuthModel, JobManagementApiService],
  exports: [AssentManagementJobService],
})
export class AssetManagementJobQueuesModule { }
